<template>
  <div class="radio-selector__options-wrapper">
    <div
      v-for="(option, i) in options"
      :key="`option-${i}`"
      :class="[
        'radio-selector__item',
        isOptionSelected(option.id) && 'radio-selector__item--selected',
      ]"
      @click="toggleOptionSelection(option)"
    >
      <div class="radio-selector__item-description">
        <span
          class="radio-selector__input"
          @click.self="toggleOptionSelection(option)"
        >
          <input
            :id="option.id"
            type="radio"
            :name="`${option.id}-checkbox`"
            :value="option.id"
            :checked="isOptionSelected(option.id)"
          />
          <span class="radio-selector__control">
            <span
              v-if="isOptionSelected(option.id)"
              :class="[
                'radio-selector__checkbox-radio-dot',
                isOptionSelected(option.id) &&
                  'radio-selector__checkbox-radio-dot--selected',
              ]"
            />
          </span>
        </span>
        <div
          class="radio-selector__item-info-container"
          @click.self="toggleOptionSelection(option)"
        >
          <div class="radio-selector__item-info-wrapper">
            <div class="radio-selector__item-name">
              {{ option.name }}
            </div>

            <div v-if="hasText(option)" class="radio-selector__item-text">
              {{ option.label.text }}
            </div>
            <div
              v-if="hasFootnote(option)"
              class="radio-selector__item-footnote"
            >
              {{ option.label.footnote }}
            </div>
          </div>
          <div v-if="hasInfo(option)" class="radio-selector__item-info">
            {{ option.label.info }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioSelectorForm',
  props: {
    options: {
      type: Array,
      required: true,
    },
    currentOption: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  created() {
    this.$emit('select-option', this.currentOption)
  },
  methods: {
    toggleOptionSelection(option) {
      this.$emit('select-option', option)
    },
    isOptionSelected(optionId) {
      return this.currentOption?.id === optionId
    },
    hasText(option) {
      return option?.label?.text
    },
    hasInfo(option) {
      return option?.label?.info
    },
    hasFootnote(option) {
      return option?.label?.footnote
    },
  },
}
</script>

<style lang="scss" scoped>
.radio-selector {
  &__checkbox-radio-dot {
    width: 10px;
    height: 10px;
    background: var(--white);
    display: inline-block;
    border-radius: 50%;
    transform: scale(0);
    transition: transform 0.2s ease-in-out;
    transform-origin: center center;
    &--selected {
      transform: scale(1);
    }
  }
  &__options-wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 5px;
    @include mobile {
      flex-wrap: wrap;
      gap: 10px;
    }
  }
  &__item {
    width: 100%;
    font-size: rem(16);
    display: flex;
    align-items: center;
    line-height: 24px;
    color: var(--white);
    padding: 10px 10px 10px 20px;
    margin-bottom: 5px;
    border-radius: 10px;
    transition: 0.2s height;
    cursor: pointer;
    min-height: 65px;
    background: var(--glass-mid-gray);
    margin: 0;
    &:hover {
      background: var(--glass-extra-light);
    }
    &:active {
      background: var(--glass-dark);
    }
    &--selected {
      .radio-selector__control {
        border-color: var(--positive-light);
        background: var(--positive-light-10);
      }
    }
    &-description {
      display: flex;
      align-items: center;
      width: 100%;
    }
    &-info-container {
      display: flex;
      gap: 15px;
      width: 100%;
      justify-content: space-between;
    }
    &-info-wrapper {
      display: flex;
      flex-direction: column;
      margin-left: 10px;
      align-items: flex-start;
    }
    &-name {
      font-size: rem(18);
      line-height: rem(24);
      font-weight: 500;
      text-align: left;
    }
    &-text {
      font-size: rem(14);
      line-height: rem(20);
      color: var(--light-blue-gray);
    }
    &-info {
      font-size: rem(24);
      font-weight: 700;
      display: flex;
      align-items: center;
    }
    &-footnote {
      font-size: rem(10);
      line-height: rem(12);
      color: var(--light-blue-gray);
    }
  }

  &__input {
    display: grid;
    &:checked {
      background: var(--purple);
      border-color: var(--purple);
    }
    input {
      display: none;
    }
  }
  &__control {
    display: inline-grid;
    width: 30px;
    height: 30px;
    border: 1px solid var(--dove-gray);
    background: transparent;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
}
</style>
